import { render } from "./v-table-h.vue?vue&type=template&id=6b821448"
import script from "./v-table-h.vue?vue&type=script&lang=js"
export * from "./v-table-h.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__